/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGIcon from '@ba-ui-toolkit/svgicon';
import styles from './DragLayer.scss';

const dragLayerClassName = styles.dragLayerClassName.replace(/"/g, '');

export default class DragLayer extends Component {
	static propTypes = {
		children: PropTypes.node,
		currentOffset: PropTypes.object.isRequired,
		droppable: PropTypes.bool.isRequired,
	};

	render() {
		const { currentOffset, droppable, children } = this.props;
		const { x, y } = currentOffset;
		const transform = `translate(${x}px, ${y}px)`;

		return (
			<div style={{ transform }} className={`${dragLayerClassName}`}>
				<span
					style={{ visibility: droppable ? 'hidden' : 'visible' }}
					className={`${dragLayerClassName}__nodrop`}
				>
					<SVGIcon size="small" iconId="common-nodrop" verticalAlign="text-bottom" />
				</span>
				{children}
			</div>
		);
	}
}
